<template>
  <div class="state-list">
    <search
      v-if="searchVisible"
      :formModel="formModel"
      :formButton="formButton"
      :deviceModelBusiType="13"
    ></search>
    <m-table
      i18n-path="query"
      :loading="loading"
      :tableData="hisData"
      :tableColumn="tableColumn"
      :pagiOption="pagiOption"
      v-on:search="search"
    ></m-table>
  </div>
</template>

<script>
import { merge } from 'lodash';

import { getHisState } from '@/api/query';
import { formatTimestamp, dayTime } from '@/utils/utils';
import { runstateDict1 } from '@/utils/dict';
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';

export default {
  name: 'QueryState',
  props: {
    sn: [String, undefined],
    runstate: [Number, undefined],
    searchTime: [Array, undefined],
    searchVisible: {
      type: Boolean,
      default: true
    }
  },
  components: { Search, MTable },
  data() {
    const { translateTo } = this.$options.filters;

    return {
      hisData: [],
      loading: true,
      formModel: {
        sn: this.sn ? [this.sn] : [],
        officeId: [],
        taskId: [],
        runstate: this.runstate !== undefined ? [this.runstate] : [],
        rangeDateVal: this.searchTime
          ? this.searchTime
          : [dayTime().begin.getTime(), dayTime().end.getTime()],
        deviceModel: []
      },
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '设备名称', prop: 'deviceName' },
        { label: '设备类型', prop: 'deviceType' },
        {
          label: '开始时间',
          prop: 'beginTime',
          temp: scope => `<span>${formatTimestamp(scope.row.beginTime)}</span>`
        },
        {
          label: '结束时间',
          prop: 'endTime',
          temp: scope => `<span>${formatTimestamp(scope.row.endTime)}</span>`
        },
        {
          label: '设备状态',
          prop: 'runstate',
          temp: scope => `<span>${translateTo(runstateDict1[scope.row.runstate], 'query')}</span>`
        }
      ],
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        }
      ]
    };
  },
  methods: {
    langChangeHandler() {
      this.search();
    },
    formatTimestamp,
    search() {
      const { formModel } = this;
      this.loading = true;
      getHisState(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
            limit: this.pagiOption.limit,
            offset: this.pagiOption.offset
          },
          formModel
        )
      )
        .then(res => {
          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.search();
  }
};
</script>

<style lang="scss">
.state-list {
  box-sizing: border-box;
}
</style>
